/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toPaymentProps } from './translator/payment'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchPayment, GetCheckPayment } from '@/infrastructure/network/Monitaro/requests/payment'

export default class Payment extends MonitaroGatewayBase {
  async FetchPayment(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchPayment(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.payments.map((prop) => toPaymentProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetCheckPayment() {
    const { check } = await this.apiClient.request(new GetCheckPayment())
    return check
  }
}
